import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { addGroupToCart } from "../../actions/closeLoop/addToCartActionCloseLoop";
import { addScenarioCloseLoop } from "../UserFunctions";
// import PopupModal from '../PopupModal.js'
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";

var scenarioNameFlag = false;
var scenarioGroupNumberFlag = false;
class BaseScenarioPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showpopup: false,
            status: "",
            group_number: 0,
            group_name: "",
        };
        this.setScenarioGroupNumber = this.setScenarioGroupNumber.bind(this);
        this.onScenarioGroupNameChange = this.onScenarioGroupNameChange.bind(this);
        this.SubmitData = this.SubmitData.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
    }

    togglePopup() {
        console.log("in togglepopup");
        this.setState((prevState) => {
            console.log("prevState", prevState);
            return {
                status: "",
                showpopup: false,
                ad_version: "",
            };
        });
        console.log(this.state.status);

        if (this.state.status === "Added Succesfully") {
            console.log("go to scenario grouping page");
            this.props.useHistory.history.push(`\close_loop_scenario_group`); // eslint-disable-line
        }
    }

    onScenarioGroupNameChange(e) {
        this.setState({ group_name: e.target.value }, () => {
            if (this.state.group_name === "") {
                scenarioNameFlag = false;
            } else {
                scenarioNameFlag = true;
                let obj = {
                    group: this.state.group_name,
                };
                this.props.dispatch(addGroupToCart(obj));
            }
        });
    }
    setScenarioGroupNumber(e) {
        const group_number = e.target.value;
        let text;
        if (isNaN(group_number) || group_number < 1 || group_number > this.props.count) {
            text = "Input invalid";
            scenarioGroupNumberFlag = false;
        } else {
            text = "Input OK";
            this.setState({ group_number: group_number }, () => {
                console.log(this.state.group_number);
                if (isNaN(this.state.group_number)) {
                    scenarioGroupNumberFlag = false;
                } else {
                    scenarioGroupNumberFlag = true;
                }
            });
        }
        document.getElementById("demo").innerHTML = text;
    }

    SubmitData() {
        console.log(scenarioNameFlag);
        console.log(scenarioGroupNumberFlag);
        // let scenario_group_uuid
        if (
            scenarioNameFlag === false ||
            scenarioGroupNumberFlag === false ||
            (scenarioNameFlag === false && scenarioGroupNumberFlag === false)
        ) {
            alert("Please fill required fields with correct data");
        } else {
            let scenario_name_array = this.props.items;
            const url = window.location.origin.concat("/base_bulk_grouping_of_scenarios");
            const data_for_addition = {
                group_name: this.props.group,
                list_of_scns: scenario_name_array,
                total_scenarios: this.props.count,
                group_number: this.state.group_number,
                scenario_group_uuid: uuidv4(),
            };
            this.props.loading();
            addScenarioCloseLoop(url, data_for_addition).then((res) => {
                console.log("response after addition : ", res["data"]["status_message"]);
                this.setState({
                    status: res["data"]["status_message"],
                    showpopup: !this.state.showpopup,
                });
                this.props.loading();
            });
            alert("Scenario Grouping has started");
            this.props.closePopup();
        }
    }
    render() {
        return (
            <div className="CartPopup">
                <Modal isOpen={true}>
                    <ModalHeader toggle={this.props.closePopup} style={{ color: "#524fa1" }}>
                        Items Added
                    </ModalHeader>
                    <ModalBody>
                        <div className="card">
                            <div className="card-body">
                                {this.props.count === 0 ? (
                                    <p>Please Select Scenarios</p>
                                ) : (
                                    <div className="form-group">
                                        <h5 style={{ color: "#008000" }}>
                                            You have selected scenarios : {this.props.count}{" "}
                                        </h5>
                                        Scenario Group Name{" "}
                                        <input
                                            type="text"
                                            className="form-control"
                                            list="data"
                                            onChange={this.onScenarioGroupNameChange}
                                            required
                                        />
                                        <div>
                                            Expected Group Number
                                            <input
                                                type="number"
                                                className="form-control"
                                                onChange={this.setScenarioGroupNumber}
                                                required
                                            />
                                            <p style={{ color: "#FF0000" }} id="demo"></p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.props.count === 0 ? (
                            <p></p>
                        ) : (
                            <Button color="" className="btn btn-primary" onClick={this.SubmitData}>
                                Add To Scenario Group
                            </Button>
                        )}
                    </ModalFooter>
                </Modal>
                {/* {this.state.showpopup ? <PopupModal text={this.state.status} closePopup={this.togglePopup.bind(this)} /> : ""} */}
            </div>
        );
    }
}
BaseScenarioPopup.defaultProps = {
    useHistory: { history: [] },
};
BaseScenarioPopup.propTypes = {
    useHistory: PropTypes.string,
    dispatch: PropTypes.string,
    items: PropTypes.string,
    group: PropTypes.string,
    closePopup: PropTypes.string,
    loading: PropTypes.string,
    count: PropTypes.string,
    ad_client_list: PropTypes.string,
};
BaseScenarioPopup.defaultProps = {
    useHistory: [],
    dispatch: [],
    items: [],
    group: [],
    closePopup: [],
    loading: [],
    count: [],
    ad_client_list: [],
};

const mapStateToProps = (state) => {
    return {
        count: state.close_loop_cart.count,
        items: state.close_loop_cart.items,
        group: state.close_loop_cart.group,
        ad_client_list: state.close_loop_cart.ad_client_list,
    };
};

export default connect(mapStateToProps)(BaseScenarioPopup);
